import React from 'react';
import './About.css';

const pillars = [
  { num: '01', title: 'The Obsession', text: 'Every supplier is visited. Every animal seen eye-to-eye. We believe the best cooking starts long before the kitchen.' },
  { num: '02', title: 'The Craft', text: 'Classical French foundations fused with East Asian precision. A decade of technique distilled into one quiet, beautiful plate.' },
  { num: '03', title: 'The Moment', text: 'Dining here should feel like a pause in time — a private world where the city outside ceases to matter.' },
];

export default function About() {
  return (
    <section className="about" id="about">
      <div className="about-bg-accent" />

      <div className="section-inner">
        <div className="about-layout">
          {/* Left: text */}
          <div className="about-left">
            <div className="gold-rule reveal">
              <span /><em>Our Story</em><span />
            </div>
            <h2 className="section-title reveal delay-1">
              Born from a single <em>obsession</em>
            </h2>
            <p className="about-body reveal delay-2">
              Aurum began not in a restaurant, but in a small apartment kitchen in Lyon, where Chef Mathieu Blanc spent three years cooking for no one but himself — perfecting a single sauce until it made him cry. Not from frustration. From joy.
            </p>
            <p className="about-body reveal delay-3">
              When he finally opened his doors in Paris, the reservations filled in 14 minutes. He pretended to be surprised. He wasn't. He had been ready for years.
            </p>

            <div className="about-pillars">
              {pillars.map((p, i) => (
                <div key={p.num} className={`about-pillar reveal delay-${i + 2}`}>
                  <span className="pillar-num">{p.num}</span>
                  <div>
                    <h4 className="pillar-title">{p.title}</h4>
                    <p className="pillar-text">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: images */}
          <div className="about-right">
            <div className="about-img-stack">
              <div className="about-img about-img--main reveal-right">
                <img
                  src="https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?w=800&auto=format&fit=crop&q=80"
                  alt="Chef plating"
                />
              </div>
              <div className="about-img about-img--accent reveal-right delay-3">
                <img
                  src="https://images.unsplash.com/photo-1559339352-11d035aa65de?w=500&auto=format&fit=crop&q=80"
                  alt="Restaurant interior"
                />
              </div>
              <div className="about-chef-quote reveal delay-4">
                <span className="about-chef-mark">"</span>
                <p>A plate is finished only when you run out of reasons to change it.</p>
                <cite>— Chef Mathieu Blanc</cite>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
